<template>
  <div class="worksList">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="无更多数据"
      @load="onLoad"
    >
      <van-cell v-for="(work, w) in worksVoList" :key="w">
        <template>
          <div
            class="map-work-box"
            v-if="form.group == 50"
            @click="toDetail(work.wid)"
          >
            <div class="cover-box">
              <img :src="work.cover" />
            </div>
            <div class="map-content">
              <p class="work-name">{{ work.name }}</p>
              <div class="uin">
                <span>{{ work.uinfo.nickname }}</span>
                <span>{{ work.uinfo.uin }}</span>
              </div>
              <div class="school">
                <img src="../assets/images/icon_location.png" />
                <span>{{ work.uinfo.schoolName }}</span>
              </div>
              <div class="down-like">
                <div class="down">
                  <img src="../assets/images/icon_download.png" />
                  <span>{{ work.downloads }}</span>
                </div>
                <div class="like">
                  <img src="../assets/images/icon_like.png" />
                  <span>{{ work.thumbUp }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="good-works-box" v-else @click="toDetail(work.wid)">
            <div class="top">
              <img :src="work.cover" />
              <div class="work-txt-box">
                <p>类型：模型</p>
                <p v-if="work.tags">标签：{{ work.tags | getTags }}</p>
              </div>
            </div>
            <div class="bottom map-content">
              <p class="work-name">{{ work.name }}</p>
              <div class="uin">
                <p>{{ work.uinfo.nickname }}</p>
                <p>{{ work.uinfo.uin }}</p>
              </div>
              <div class="school">
                <img src="../assets/images/icon_location.png" />
                <span>{{ work.uinfo.schoolName }}</span>
              </div>
              <div class="down-like">
                <div class="down">
                  <img src="../assets/images/icon_download.png" />
                  <span>{{ work.downloads }}</span>
                </div>
                <div class="like">
                  <img src="../assets/images/icon_like.png" />
                  <span>{{ work.thumbUp }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { seasonId, divisionIdM, divisionIdG } from '../common/argumentId';
export default {
  name: 'classifyWork',
  props: {
    rankingType: {
      type: String,
      default: 'normal'
    },
    uid: {
      type: String
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      worksVoList: [],
      loading: false,
      hasWorks: false,
      finished: false
    };
  },
  mounted() {
    this.queryWorks();
  },
  watch: {
    uid: function() {
      Object.assign(this.$data, this.$options.data());
      this.queryWorks();
    },
    'form.school': function(val) {
      Object.assign(this.$data, this.$options.data());
      if (val) {
        this.queryWorks();
      }
    },
    'form.group': function() {
      Object.assign(this.$data, this.$options.data());
      this.queryWorks();
    },
    rankingType: function() {
      Object.assign(this.$data, this.$options.data());
      this.queryWorks();
    },
    worksVoList: function() {
      if (this.worksVoList.length >= this.total) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    }
  },
  methods: {
    onLoad() {
      this.pageNum++;
      this.queryWorks();
    },
    async queryWorks() {
      let divisionId = this.form.group == 60 ? divisionIdG : divisionIdM;
      let body = {
        seasonId,
        divisionId,
        rankingType: this.rankingType,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.form.school) {
        Object.assign(body, { sid: this.form.school });
      }
      if (this.uid) {
        Object.assign(body, { uid: this.uid });
      }
      try {
        this.loading = true;
        const res = await this.$http.apiRanking(body);
        const { data } = res.data;
        this.total = data.total;
        if (!data.worksVoList.length) {
          this.finished = true;
        } else {
          this.worksVoList = [...this.worksVoList, ...data.worksVoList];
        }

        this.loading = false;
      } catch (error) {
        this.finished = true;
        this.loading = false;
        console.log(error);
      }
    },
    toDetail(wid) {
      let divisionId = this.form.group == 60 ? divisionIdG : divisionIdM;
      this.$router.push(`details/${divisionId}/${wid}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.worksList {
  // width: 750px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 26px;
  color: rgb(53, 53, 53);
  margin-top: 30px;

  .img-loading {
    color: #ff874b;
    margin: 40px;
    .van-loading__text {
      font-size: 26px;
    }
  }
  .noWorks {
    height: 50px;
    font-size: 30px;
  }
}
.van-list {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .van-cell {
    width: 340px;
    margin-bottom: 15px;
    padding: 0;
    font-size: 24px;
  }
}
.van-cell::after {
  border-bottom: none;
}
.map-work-box,
.good-works-box {
  width: 340px;
  display: flex;
  flex-direction: column;
  .cover-box {
    width: 340px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      // width: 340px;
      // height: 150px;
    }
  }

  .map-content {
    height: 200px;
    padding: 10px 20px;

    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .uin {
      display: flex;
      justify-content: space-between;
    }
    .school {
      margin: 5px 0;
      img {
        width: 20px;
        height: 25px;
      }
    }
    .down-like {
      display: flex;
      justify-content: space-between;
      .down,
      .like {
        display: flex;
        align-items: center;
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    img {
      margin-right: 10px;
    }
  }
}
.work-name {
  color: #e8b152;
  font-size: 26px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}
.good-works-box {
  display: flex;
  flex-direction: column;
  .top {
    display: flex;
    justify-content: space-between;
    img {
      width: 140px;
      height: 140px;
      background: url('../assets/images/bg_resbg.png') no-repeat top
        center/140px 140px;
      background-color: #f3f3f3;
    }
    .work-txt-box {
      padding: 10px 0 10px 10px;
      width: 200px;
      background-color: #f3f3f3;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }

  .bottom {
    padding: 20px 20px 10px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: #f7f7f7;
    img {
      margin-right: 10px;
    }
    .uin {
      display: flex;
      justify-content: space-between;
    }
    .school {
      margin: 5px 0;
      img {
        width: 15px;
        height: 20px;
      }
    }
    .down-like {
      display: flex;
      justify-content: space-between;
      .down,
      .like {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
/deep/ .van-list__finished-text {
  width: 750px;
  line-height: 100px;
  font-size: 28px;
}
</style>
